import { createRef } from 'react'
export default class BooleanSelectInput extends React.Component {
  constructor (props) {
    super()
    this.state = {
      options: []
    }
    this.currentSelectRef = createRef(null)
  }

  componentDidMount () {
    const select2Options = {
      minimumResultsForSearch: -1,
      placeholder: this.props.placeholder || '',
      allowClear: this.props.allowClear,
      dropdownCssClass: `${this.props.field}_select2_results`
    }

    this.select2 = $(this.currentSelectRef).select2(select2Options).data('select2')

    $(this.currentSelectRef).on('change change.select2 select2-open select2-close select2-select', (e) => {
      this.select2.container.attr('data-label', e.target.value ? this.props.placeholder || '' : '')
        .toggleClass('show-labelholder', !!e.target.value)
    })
    $(this.currentSelectRef).on('change', (e) => {
      // Callback
      if (typeof this.props.onSelect === 'function') this.props.onSelect(e)
    })
  }

  componentDidUpdate () {
    $(this.currentSelectRef).trigger('change.select2')
  }

  render () {
    return (
      <select
        className='labelholder'
        data-label={this.props.placeholder || ''}
        name={this.props.name}
        defaultValue={this.props.value}
        onChange={() => { }}
        ref={this.currentSelectRef}
        id={this.props.field}
        disabled={this.props.disabled}
      >
        <option />
        <option value='1'>{I18n.t('layouts.common.true')}</option>
        <option value='0'>{I18n.t('layouts.common.false')}</option>
      </select>
    )
  }
}

BooleanSelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  onSelect: PropTypes.func,
  allowClear: PropTypes.bool,
  onClear: PropTypes.func,
  disabled: PropTypes.bool
}
